import React, { useState, useRef } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import CustomTable from "../../common/CustomTable/CustomTable";
import moment from "moment";
import queryString from "query-string";
import SystemService from "../../../services/SystemService";
import _ from "lodash";
import { navigate } from "@reach/router";
import ProfileModal from "../../pages/ProfileDetails/components/ProfileModal";
import labels from "../../../helpers/labels.json";
import { parseTimeStamp } from "../../../helpers/functions";

async function getProfiles(query = "") {
  try {
    const response = await SystemService.getProfiles(query);
    return { ...response };
  } catch (error) {
    return error;
  }
}

const MediatorListing = () => {
  const [state, setState] = useState({});
  const placeholderText = labels.search_neutral;
  const MTRef = useRef();
  const [modal, setModal] = useState();
  const [user, setUser] = useState();

  const commonStyle = {
    minWidth: 120,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const columns = [
    {
      field: "id",
      title: labels.id_type,
      tooltip: "Unique Identifier for the Mediator across JustAct platform",
      render: (rowData) => (
        <HyperLink
          onClick={() => navigate("/dashboard/mediator/" + rowData.id)}
        >
          {rowData.id}
        </HyperLink>
      ),
      headerStyle: commonStyle,
      cellStyle: commonStyle,
    },
    {
      field: "name",
      title: labels.profile_name,
      render: (rowData) => (
        <Bold onClick={() => navigate("/dashboard/mediator/" + rowData.id)}>
          {rowData.name}
        </Bold>
      ),
      sorting: false,
      headerStyle: commonStyle,
      cellStyle: commonStyle,
    },
    {
      field: "email",
      tooltip: "Email associated with the Mediator",
      title: labels.profile_email,
      sorting: false,
      headerStyle: { ...commonStyle, minWidth: 150 },
      cellStyle: { ...commonStyle, minWidth: 150 },
    },
    {
      field: "created_at",
      title: labels.created_on,
      tooltip: "Mediator Created Date",
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}</>
      ),
      headerStyle: commonStyle,
      cellStyle: commonStyle,
    },
    {
      field: "action",
      title: labels.actions.substring(0, labels.actions.length - 1),
      sorting: false,
      render: (rowData) => (
        <HyperLink
          onClick={() => {
            setUser(rowData);
            setModal(true);
          }}
        >
          {labels.edit_mediator}
        </HyperLink>
      ),
      tooltip: "Option to edit Mediator profile",
      headerStyle: commonStyle,
      cellStyle: commonStyle,
    },
  ];

  const data = (query) =>
    new Promise((resolve, reject) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      params.role = "mediator";
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getProfiles(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  return (
    <Padding>
      <CustomTable
        hideFilterBar
        hidePagination={state.lastPage === 1}
        pageSize={state?.data?.length ? state?.data?.length : 10}
        pluralTitle={_.startCase(labels.mediator)}
        singularTitle=""
        onFilterClick={() => setModal(true)}
        {...{
          columns,
          data,
          placeholderText,
          MTRef,
        }}
        state={state}
      />
      <ProfileModal
        setUser={() => {
          setUser({});
          MTRef.current.onQueryChange();
        }}
        {...{ modal, setModal, user }}
      />
    </Padding>
  );
};

export default MediatorListing;

const Padding = styled.div`
  padding-bottom: 50px;
`;

const HyperLink = styled.span`
  cursor: pointer;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
`;

const Bold = styled.span`
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
